import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createBlock as _createBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
import _imports_0 from '@/assets/images/icons/SocialLinks/Twitter.svg';
import _imports_1 from '@/assets/images/icons/SocialLinks/poster.svg';
const _withScopeId = n => (_pushScopeId("data-v-b2f89f6c"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "row"
};
const _hoisted_2 = {
  class: "col-lg-4 col-12"
};
const _hoisted_3 = {
  class: "referrals-card"
};
const _hoisted_4 = {
  class: ""
};
const _hoisted_5 = {
  key: 0,
  class: "mb-2"
};
const _hoisted_6 = {
  class: "d-flex justify-content-between align-items-center"
};
const _hoisted_7 = {
  class: "w-100"
};
const _hoisted_8 = {
  class: ""
};
const _hoisted_9 = {
  class: "mr-1 fw-bold"
};
const _hoisted_10 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "transform": "translateY(2px)"
  },
  class: "cursor-pointer icon-hover"
}, null, -1));
const _hoisted_11 = {
  class: "mt-1"
};
const _hoisted_12 = {
  class: "fw-medium fsi-24"
};
const _hoisted_13 = {
  key: 0,
  class: "w-100"
};
const _hoisted_14 = {
  class: "w-100",
  style: {
    "color": "#909090"
  }
};
const _hoisted_15 = {
  key: 0,
  class: "d-flex flex-column"
};
const _hoisted_16 = {
  class: "fs-12",
  style: {
    "color": "rgb(16, 27, 82)!important"
  }
};
const _hoisted_17 = {
  class: "fs-12"
};
const _hoisted_18 = {
  class: "d-flex align-items-center"
};
const _hoisted_19 = {
  style: {
    "transform": "translateY(2px)",
    "margin-right": "5px"
  }
};
const _hoisted_20 = {
  key: 1
};
const _hoisted_21 = {
  key: 0,
  class: "d-flex flex-column"
};
const _hoisted_22 = {
  class: "fs-12",
  style: {
    "color": "rgb(16, 27, 82)!important"
  }
};
const _hoisted_23 = {
  class: "fs-12"
};
const _hoisted_24 = {
  key: 1,
  class: "d-flex align-items-center"
};
const _hoisted_25 = {
  key: 0,
  style: {
    "transform": "translateY(2px)",
    "margin-right": "5px"
  }
};
const _hoisted_26 = {
  key: 1,
  style: {
    "transform": "translateY(2px)",
    "margin-right": "5px"
  }
};
const _hoisted_27 = {
  class: "d-flex align-items-center"
};
const _hoisted_28 = {
  key: 0,
  style: {
    "transform": "translateY(2px)",
    "margin-right": "5px"
  }
};
const _hoisted_29 = {
  key: 1,
  style: {
    "transform": "translateY(2px)",
    "margin-right": "5px"
  }
};
const _hoisted_30 = {
  key: 2,
  class: "w-100"
};
const _hoisted_31 = {
  class: "d-flex justify-content-between"
};
const _hoisted_32 = {
  key: 0
};
const _hoisted_33 = {
  class: "fs-12",
  style: {
    "color": "#39dccf"
  }
};
const _hoisted_34 = {
  class: "p-2"
};
const _hoisted_35 = {
  class: "position-relative mb-2 mt-1"
};
const _hoisted_36 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "borrow-progress-bar",
  style: {
    "height": "12px",
    "border-radius": "12px"
  }
}, null, -1));
const _hoisted_37 = {
  key: 3,
  class: "d-flex align-items-start"
};
const _hoisted_38 = {
  style: {
    "transform": "translateY(-1px)",
    "margin-right": "5px"
  }
};
const _hoisted_39 = ["innerHTML"];
const _hoisted_40 = {
  key: 1,
  class: "mb-2"
};
const _hoisted_41 = {
  class: "d-flex justify-content-between align-items-center"
};
const _hoisted_42 = {
  class: "flex-center"
};
const _hoisted_43 = {
  class: "mr-1 fw-bold"
};
const _hoisted_44 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "transform": "translateY(2px)"
  },
  class: "cursor-pointer icon-hover"
}, null, -1));
const _hoisted_45 = {
  class: "mt-1"
};
const _hoisted_46 = {
  class: "fw-medium fsi-24"
};
const _hoisted_47 = {
  key: 2,
  class: "fw-medium fsi-14"
};
const _hoisted_48 = {
  class: "mt-2"
};
const _hoisted_49 = {
  key: 0,
  class: "mt-3 copy-text"
};
const _hoisted_50 = {
  class: "fsi-14"
};
const _hoisted_51 = {
  class: "fsi-14"
};
const _hoisted_52 = {
  class: "mt-3"
};
const _hoisted_53 = {
  class: "fsi-14"
};
const _hoisted_54 = {
  class: "col-lg-8 col-12 pl-lg-2"
};
const _hoisted_55 = {
  class: "row mt-lg-0 mt-3"
};
const _hoisted_56 = {
  class: "col-md-6 col-12 referrals-col-spacing referrals-col-spacing-left"
};
const _hoisted_57 = {
  class: "referrals-card"
};
const _hoisted_58 = {
  class: "d-flex align-items-center"
};
const _hoisted_59 = {
  class: "fw-bold"
};
const _hoisted_60 = {
  class: "col-md-6 col-12 mt-lg-0 mt-3 referrals-col-spacing referrals-col-spacing-right"
};
const _hoisted_61 = {
  class: "referrals-card"
};
const _hoisted_62 = {
  class: "d-flex align-items-center"
};
const _hoisted_63 = {
  class: "fw-bold"
};
const _hoisted_64 = {
  class: "row mt-3"
};
const _hoisted_65 = {
  class: "col-md-6 col-12 referrals-col-spacing referrals-col-spacing-left"
};
const _hoisted_66 = {
  class: "referrals-card"
};
const _hoisted_67 = {
  class: "d-flex align-items-center"
};
const _hoisted_68 = {
  class: "fw-bold"
};
const _hoisted_69 = {
  class: "col-md-6 col-12 mt-lg-0 mt-3 referrals-col-spacing referrals-col-spacing-right"
};
const _hoisted_70 = {
  class: "referrals-card position-relative"
};
const _hoisted_71 = {
  class: "d-flex align-items-center justify-content-between"
};
const _hoisted_72 = {
  class: "d-flex align-items-center"
};
const _hoisted_73 = {
  class: "mr-1 fw-bold"
};
const _hoisted_74 = {
  style: {
    "position": "absolute",
    "right": "1rem",
    "top": "1.2rem"
  }
};
const _hoisted_75 = {
  class: "fw-medium"
};
const _hoisted_76 = {
  class: "row"
};
const _hoisted_77 = {
  class: "col-12 mt-3"
};
const _hoisted_78 = {
  class: "referrals-card",
  style: {
    "padding-top": "1rem"
  }
};
const _hoisted_79 = {
  class: "mb-3 d-flex justify-content-between"
};
const _hoisted_80 = {
  class: "fsi-18 fw-bold text-left"
};
const _hoisted_81 = {
  class: "fs-12"
};
const _hoisted_82 = {
  style: {
    "transform": "translateY(2px)",
    "margin-right": "2px"
  }
};
const _hoisted_83 = {
  key: 0
};
const _hoisted_84 = {
  class: "d-flex justify-content-start align-items-center align-content-center"
};
const _hoisted_85 = {
  style: {
    "width": "22%"
  },
  class: "text-left fs-12"
};
const _hoisted_86 = {
  style: {
    "width": "20%"
  },
  class: "text-left fs-12"
};
const _hoisted_87 = {
  style: {
    "width": "40%"
  },
  class: "text-left fs-12"
};
const _hoisted_88 = {
  style: {
    "width": "18%"
  },
  class: "text-center fs-12"
};
const _hoisted_89 = {
  class: "d-flex justify-content-start align-items-center align-content-center"
};
const _hoisted_90 = {
  style: {
    "width": "22%"
  },
  class: "text-left fsi-14"
};
const _hoisted_91 = {
  style: {
    "width": "20%"
  },
  class: "text-left fsi-14"
};
const _hoisted_92 = {
  style: {
    "width": "40%"
  },
  class: "text-left fsi-14"
};
const _hoisted_93 = {
  style: {
    "width": "18%"
  },
  class: "text-center fsi-14"
};
const _hoisted_94 = {
  class: "d-flex justify-content-center align-items-center"
};
const _hoisted_95 = ["onClick"];
const _hoisted_96 = {
  key: 1,
  class: "cursor-pointer fsi-14",
  style: {
    "color": "#d2d1d1"
  }
};
const _hoisted_97 = {
  class: "ml-3"
};
const _hoisted_98 = ["onClick"];
const _hoisted_99 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  style: {
    "width": "16px",
    "margin-bottom": "4px"
  },
  alt: ""
}, null, -1));
const _hoisted_100 = [_hoisted_99];
const _hoisted_101 = {
  class: "ml-3"
};
const _hoisted_102 = ["onClick"];
const _hoisted_103 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  style: {
    "width": "16px",
    "margin-bottom": "4px"
  },
  alt: ""
}, null, -1));
const _hoisted_104 = [_hoisted_103];
const _hoisted_105 = {
  key: 1,
  class: "text-center mb-3"
};
const _hoisted_106 = {
  class: "fs-12 opacity-06"
};
const _hoisted_107 = {
  class: "col-12 mt-3"
};
const _hoisted_108 = {
  class: "referrals-card",
  style: {
    "padding-top": "1rem",
    "padding-bottom": "1rem"
  }
};
const _hoisted_109 = {
  class: "mb-3"
};
const _hoisted_110 = {
  class: "fsi-18 fw-bold text-left"
};
const _hoisted_111 = {
  class: "fs-12"
};
const _hoisted_112 = {
  key: 0
};
const _hoisted_113 = {
  class: "d-flex justify-content-start align-items-center align-content-center"
};
const _hoisted_114 = {
  style: {
    "width": "40%"
  },
  class: "text-left fs-12"
};
const _hoisted_115 = {
  style: {
    "width": "40%"
  },
  class: "text-left fs-12"
};
const _hoisted_116 = {
  style: {
    "width": "20%"
  },
  class: "text-center fs-12"
};
const _hoisted_117 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_118 = {
  class: "d-flex justify-content-start align-items-center align-content-center"
};
const _hoisted_119 = {
  style: {
    "width": "40%"
  },
  class: "text-left fsi-14"
};
const _hoisted_120 = {
  style: {
    "width": "40%"
  },
  class: "text-left fsi-14"
};
const _hoisted_121 = {
  style: {
    "width": "20%"
  },
  class: "text-center fsi-14"
};
const _hoisted_122 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center mt-4"
};
const _hoisted_123 = {
  key: 1,
  class: "text-center mb-3"
};
const _hoisted_124 = {
  class: "fs-12 opacity-06"
};
const _hoisted_125 = {
  class: "col-12 mt-3"
};
const _hoisted_126 = {
  class: "referrals-card",
  style: {
    "padding-top": "1rem",
    "padding-bottom": "1rem"
  }
};
const _hoisted_127 = {
  class: "mb-3 d-flex justify-content-between align-items-center"
};
const _hoisted_128 = {
  class: "fsi-18 fw-bold text-left"
};
const _hoisted_129 = {
  class: "d-flex justify-content-start align-items-center align-content-center"
};
const _hoisted_130 = {
  style: {
    "width": "30%"
  },
  class: "text-left fs-12"
};
const _hoisted_131 = {
  style: {
    "width": "30%"
  },
  class: "text-left fs-12"
};
const _hoisted_132 = {
  style: {
    "width": "20%"
  },
  class: "text-left fs-12"
};
const _hoisted_133 = {
  style: {
    "width": "20%"
  },
  class: "text-center fs-12"
};
const _hoisted_134 = {
  class: "d-flex justify-content-start align-items-center align-content-center"
};
const _hoisted_135 = {
  style: {
    "width": "30%"
  },
  class: "text-left fsi-14"
};
const _hoisted_136 = {
  key: 0
};
const _hoisted_137 = {
  key: 1,
  class: "fs-12"
};
const _hoisted_138 = {
  style: {
    "width": "30%"
  },
  class: "text-left fsi-14"
};
const _hoisted_139 = {
  style: {
    "width": "20%"
  },
  class: "text-left fsi-14"
};
const _hoisted_140 = {
  style: {
    "width": "20%"
  },
  class: "text-center fsi-14"
};
const _hoisted_141 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center mt-4"
};
const _hoisted_142 = {
  key: 0,
  class: "text-center mb-2 mt-3"
};
const _hoisted_143 = {
  class: "fs-12 opacity-06"
};
const _hoisted_144 = {
  class: "row"
};
const _hoisted_145 = {
  class: "col-12 mt-3"
};
const _hoisted_146 = {
  class: "referrals-card",
  style: {
    "padding-top": "1rem",
    "padding-bottom": "1rem"
  }
};
const _hoisted_147 = {
  class: "mb-3"
};
const _hoisted_148 = {
  class: "fsi-18 fw-bold text-left"
};
const _hoisted_149 = {
  key: 0
};
const _hoisted_150 = {
  class: "d-flex justify-content-start align-items-center align-content-center"
};
const _hoisted_151 = {
  style: {
    "width": "30%"
  },
  class: "text-left fs-12"
};
const _hoisted_152 = {
  style: {
    "width": "30%"
  },
  class: "text-left fs-12"
};
const _hoisted_153 = {
  style: {
    "width": "20%"
  },
  class: "text-left fs-12"
};
const _hoisted_154 = {
  style: {
    "width": "20%"
  },
  class: "text-center fs-12"
};
const _hoisted_155 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1));
const _hoisted_156 = {
  class: "d-flex justify-content-start align-items-center align-content-center"
};
const _hoisted_157 = {
  style: {
    "width": "30%"
  },
  class: "text-left fsi-14"
};
const _hoisted_158 = {
  style: {
    "width": "30%"
  },
  class: "text-left fsi-14"
};
const _hoisted_159 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  style: {
    "width": "20%"
  },
  class: "text-left fsi-14"
}, " 0.01FIL ", -1));
const _hoisted_160 = {
  style: {
    "width": "20%"
  },
  class: "text-center fsi-14"
};
const _hoisted_161 = {
  key: 0
};
const _hoisted_162 = {
  key: 1,
  class: "flex-center"
};
const _hoisted_163 = {
  class: "ml-1"
};
const _hoisted_164 = {
  key: 0,
  class: "d-flex justify-content-center align-items-center mt-4"
};
const _hoisted_165 = {
  key: 1,
  class: "text-center mb-3"
};
const _hoisted_166 = {
  class: "fs-12 opacity-06"
};
const _hoisted_167 = {
  class: "mt-2"
};
const _hoisted_168 = {
  style: {
    "color": "#f81515"
  },
  class: "fs-12"
};
const _hoisted_169 = {
  class: "mt-3"
};
const _hoisted_170 = ["src"];
const _hoisted_171 = {
  style: {
    "position": "absolute",
    "bottom": "0",
    "width": "100%",
    "transform": "translateY(105px)"
  }
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Warning = _resolveComponent("Warning");
  const _component_el_icon = _resolveComponent("el-icon");
  const _component_CircleCheckFilled = _resolveComponent("CircleCheckFilled");
  const _component_el_tooltip = _resolveComponent("el-tooltip");
  const _component_Share = _resolveComponent("Share");
  const _component_el_button = _resolveComponent("el-button");
  const _component_CirclePlus = _resolveComponent("CirclePlus");
  const _component_Refresh = _resolveComponent("Refresh");
  const _component_CopyDocument = _resolveComponent("CopyDocument");
  const _component_el_pagination = _resolveComponent("el-pagination");
  const _component_SuccessFilled = _resolveComponent("SuccessFilled");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_dialog = _resolveComponent("el-dialog");
  const _component_CircleClose = _resolveComponent("CircleClose");
  const _directive_loading = _resolveDirective("loading");
  return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_ctx.addressReferralCodes && _ctx.addressReferralCodes.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createElementVNode("div", _hoisted_8, [_createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('Referrals.Your Identity')), 1), _hoisted_10]), _createElementVNode("div", _hoisted_11, [_createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t($data.LeveLabel[_ctx.level])), 1)]), _ctx.isSkipFinalSuperTarget !== true ? (_openBlock(), _createElementBlock("div", _hoisted_13, [_createElementVNode("div", _hoisted_14, [_ctx.level < 2 ? (_openBlock(), _createElementBlock("div", _hoisted_15, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.$t('Referrals.Next Level')) + ": " + _toDisplayString(_ctx.$t($data.LeveLabel[_ctx.level + 1])), 1)]), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.$t('Referrals.Upgrade condition')) + ":", 1)]), _createElementVNode("div", _hoisted_18, [_createElementVNode("div", _hoisted_19, [_createVNode(_component_el_icon, {
    size: "13"
  }, {
    default: _withCtx(() => [_createVNode(_component_Warning)]),
    _: 1
  })]), _createElementVNode("div", {
    class: "fs-12 link-text-ordinary",
    onClick: _cache[0] || (_cache[0] = (...args) => $options.gotoNft2 && $options.gotoNft2(...args))
  }, _toDisplayString(_ctx.$t('Referrals.Staking one NFT')), 1)])])) : _createCommentVNode("", true), _ctx.level === 2 || _ctx.level === 3 ? (_openBlock(), _createElementBlock("div", _hoisted_20, [_ctx.level < 3 ? (_openBlock(), _createElementBlock("div", _hoisted_21, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t('Referrals.Next Level')) + ": " + _toDisplayString(_ctx.$t($data.LeveLabel[_ctx.level + 1])), 1)]), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t('Referrals.Upgrade condition')) + ":", 1)])])) : _createCommentVNode("", true), _ctx.level < 3 ? (_openBlock(), _createElementBlock("div", _hoisted_24, [!_ctx.superTargetStFilBalanceIsReach ? (_openBlock(), _createElementBlock("div", _hoisted_25, [_createVNode(_component_el_icon, {
    size: "13"
  }, {
    default: _withCtx(() => [_createVNode(_component_Warning)]),
    _: 1
  })])) : _createCommentVNode("", true), _ctx.superTargetStFilBalanceIsReach ? (_openBlock(), _createElementBlock("div", _hoisted_26, [_createVNode(_component_el_icon, {
    size: "13"
  }, {
    default: _withCtx(() => [_createVNode(_component_CircleCheckFilled, {
      color: "#00CE92"
    })]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("span", {
    style: _normalizeStyle({
      color: _ctx.superTargetStFilBalanceIsReach ? '#00CE92' : ''
    }),
    class: "fs-12"
  }, _toDisplayString(_ctx.$t('Referrals.stFIL balance greater than')) + _toDisplayString($options.formatWalletFilPrice(_ctx.superTargetStFilBalance, 4, false, false, true)), 5)])])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_27, [!_ctx.isFinalSuperTarget ? (_openBlock(), _createElementBlock("div", _hoisted_28, [_createVNode(_component_el_icon, {
    size: "13"
  }, {
    default: _withCtx(() => [_createVNode(_component_Warning)]),
    _: 1
  })])) : _createCommentVNode("", true), _ctx.isFinalSuperTarget ? (_openBlock(), _createElementBlock("div", _hoisted_29, [_createVNode(_component_el_icon, {
    size: "13"
  }, {
    default: _withCtx(() => [_createVNode(_component_CircleCheckFilled, {
      color: "#00CE92"
    })]),
    _: 1
  })])) : _createCommentVNode("", true), _createElementVNode("div", null, [_createElementVNode("span", {
    class: "fs-12",
    style: _normalizeStyle({
      color: _ctx.isFinalSuperTarget ? '#00CE92' : ''
    })
  }, _toDisplayString(_ctx.$t('Referrals.Complete cycle goals obtain rare NFT and pledge')), 5)])]), !_ctx.isFinalSuperTarget || _ctx.isWaitHighWlMintState ? (_openBlock(), _createElementBlock("div", _hoisted_30, [_createElementVNode("div", _hoisted_31, [_createElementVNode("div", null, [_createElementVNode("span", {
    class: "fs-12",
    style: _normalizeStyle({
      color: _ctx.interestRate >= 100 ? '#39dccf' : ''
    })
  }, _toDisplayString(_ctx.$t('Referrals.Progress')) + ": " + _toDisplayString(_ctx.interestRate) + "%", 5)]), _ctx.interestRate >= 100 ? (_openBlock(), _createElementBlock("div", _hoisted_32, [_createElementVNode("span", _hoisted_33, _toDisplayString(_ctx.$t('Referrals.Waiting to airdrop rare NFT')), 1)])) : _createCommentVNode("", true)]), _createVNode(_component_el_tooltip, {
    "raw-content": "",
    placement: "bottom-end",
    effect: "light",
    disabled: _ctx.totalInterest >= _ctx.superTarget
  }, {
    content: _withCtx(() => [_createElementVNode("div", _hoisted_34, [_createElementVNode("div", null, _toDisplayString(_ctx.$t('nft.Next epoch')) + ": " + _toDisplayString(_ctx.nextEpochShow), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('Referrals.Total Rebates')) + " : " + _toDisplayString($options.formatWalletFilPrice(_ctx.totalInterest, 4, false, false, true)), 1), _createElementVNode("div", null, _toDisplayString(_ctx.$t('Referrals.Target')) + " : " + _toDisplayString($options.formatWalletFilPrice(_ctx.superTarget, 4, false, false, true)), 1)])]),
    default: _withCtx(() => [_createElementVNode("div", _hoisted_35, [_hoisted_36, _createElementVNode("div", {
      class: "borrow-current-progress-indicate",
      style: _normalizeStyle({
        width: _ctx.interestRate + '%',
        height: '12px',
        borderRadius: '12px'
      })
    }, null, 4)])]),
    _: 1
  }, 8, ["disabled"])])) : _createCommentVNode("", true), _ctx.isFinalSuperTarget && !_ctx.isWaitHighWlMintState ? (_openBlock(), _createElementBlock("div", _hoisted_37, [_createElementVNode("div", _hoisted_38, [_createVNode(_component_el_icon, {
    size: "13"
  }, {
    default: _withCtx(() => [_createVNode(_component_Warning)]),
    _: 1
  })]), _createElementVNode("div", {
    class: "fs-12",
    innerHTML: _ctx.$t('Referrals.super_rule2'),
    onClick: _cache[1] || (_cache[1] = (...args) => $options.gotoNft2 && $options.gotoNft2(...args))
  }, null, 8, _hoisted_39)])) : _createCommentVNode("", true)])) : _createCommentVNode("", true)])])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true), _ctx.addressReferralCodes && _ctx.addressReferralCodes.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_40, [_createElementVNode("div", _hoisted_41, [_createElementVNode("div", null, [_createElementVNode("div", _hoisted_42, [_createElementVNode("span", _hoisted_43, _toDisplayString(_ctx.$t('Referrals.commissionRate')), 1), _hoisted_44]), _createElementVNode("div", _hoisted_45, [_createElementVNode("span", _hoisted_46, _toDisplayString(_ctx.subordinateRatio) + "%", 1)])])])])) : _createCommentVNode("", true), !_ctx.addressReferralCodes || _ctx.addressReferralCodes.length === 0 ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(_ctx.$t('Referrals.ReferralTip')), 1)) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_48, [!_ctx.addressReferralCodes || _ctx.addressReferralCodes.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_49, [!$data.isCopySharLine ? (_openBlock(), _createBlock(_component_el_button, {
    key: 0,
    class: "btn btn-success w-100 i-button",
    onClick: $options.copySharLink
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_Share)]),
      _: 1
    }), _createElementVNode("span", _hoisted_50, _toDisplayString(_ctx.$t('Referrals.copyGenerateCode')), 1)]),
    _: 1
  }, 8, ["onClick"])) : _createCommentVNode("", true), $data.isCopySharLine ? (_openBlock(), _createBlock(_component_el_button, {
    key: 1,
    class: "btn btn-success w-100 i-button"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_CircleCheckFilled)]),
      _: 1
    }), _createElementVNode("span", _hoisted_51, _toDisplayString(_ctx.$t('Referrals.copyGenerateCodeOk')), 1)]),
    _: 1
  })) : _createCommentVNode("", true)])) : _createCommentVNode("", true), _createElementVNode("div", _hoisted_52, [_createVNode(_component_el_button, {
    class: "btn btn-primary w-100 i-button",
    onClick: $options.generateCodeShow
  }, {
    default: _withCtx(() => [_createVNode(_component_el_icon, null, {
      default: _withCtx(() => [_createVNode(_component_CirclePlus, {
        color: "#fff"
      })]),
      _: 1
    }), _createElementVNode("span", _hoisted_53, _toDisplayString(!_ctx.addressReferralCodes || _ctx.addressReferralCodes.length === 0 ? _ctx.$t('Referrals.GenerateCode') : _ctx.$t('Referrals.GenerateCodeNew')), 1)]),
    _: 1
  }, 8, ["onClick"])])])])]), _createElementVNode("div", _hoisted_54, [_createElementVNode("div", _hoisted_55, [_createElementVNode("div", _hoisted_56, [_createElementVNode("div", _hoisted_57, [_createElementVNode("div", _hoisted_58, [_createElementVNode("span", _hoisted_59, _toDisplayString(_ctx.$t('Referrals.Total Referral Stake')), 1)]), _createElementVNode("div", null, _toDisplayString($options.formatWalletFilPrice(_ctx.totalStake, 4, false, false, true)), 1)])]), _createElementVNode("div", _hoisted_60, [_createElementVNode("div", _hoisted_61, [_createElementVNode("div", _hoisted_62, [_createElementVNode("span", _hoisted_63, _toDisplayString(_ctx.$t('Referrals.Total Referral Interest')), 1)]), _createElementVNode("div", null, _toDisplayString($options.formatWalletFilPrice(_ctx.allTotalInterest, 4, false, false, true)), 1)])])]), _createElementVNode("div", _hoisted_64, [_createElementVNode("div", _hoisted_65, [_createElementVNode("div", _hoisted_66, [_createElementVNode("div", _hoisted_67, [_createElementVNode("span", _hoisted_68, _toDisplayString(_ctx.$t('Referrals.Total Referral Rebates')), 1)]), _createElementVNode("div", null, _toDisplayString($options.formatWalletFilPrice(_ctx.commission || 0n, 4, false, false, true)), 1)])]), _createElementVNode("div", _hoisted_69, [_createElementVNode("div", _hoisted_70, [_createElementVNode("div", _hoisted_71, [_createElementVNode("div", _hoisted_72, [_createElementVNode("span", _hoisted_73, _toDisplayString(_ctx.$t('Referrals.Total Amount Withdrawn')), 1)]), _createElementVNode("div", _hoisted_74, [_createVNode(_component_el_button, {
    disabled: _ctx.withdrawn <= 0n,
    class: "btn btn-success reward-button",
    loading: _ctx.addWithdrawLoading,
    round: "",
    onClick: $options.withdraw
  }, {
    default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Referrals.Withdraw commission')), 1)]),
    _: 1
  }, 8, ["disabled", "loading", "onClick"])])]), _createElementVNode("div", null, [_createElementVNode("span", _hoisted_75, _toDisplayString($options.formatWalletFilPrice(_ctx.withdrawn || 0n, 4, false, true)), 1)])])])]), _createElementVNode("div", _hoisted_76, [_createElementVNode("div", _hoisted_77, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_78, [_createElementVNode("div", _hoisted_79, [_createElementVNode("span", _hoisted_80, [_createTextVNode(_toDisplayString(_ctx.$t('Referrals.Referral Codes')), 1), _createElementVNode("span", _hoisted_81, "(" + _toDisplayString(_ctx.addressReferralCodes.length) + ")", 1)]), _ctx.isConnected && $data.showFreshBtn ? (_openBlock(), _createElementBlock("span", {
    key: 0,
    onClick: _cache[2] || (_cache[2] = (...args) => $options.refreshCode && $options.refreshCode(...args)),
    class: "link-text flex-center refresh-code"
  }, [_createElementVNode("span", _hoisted_82, [_createVNode(_component_el_icon, null, {
    default: _withCtx(() => [_createVNode(_component_Refresh)]),
    _: 1
  })]), _createElementVNode("span", null, _toDisplayString(_ctx.$t('Referrals.refresh')), 1)])) : _createCommentVNode("", true)]), _ctx.addressReferralCodes && _ctx.addressReferralCodes.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_83, [_createElementVNode("div", _hoisted_84, [_createElementVNode("div", _hoisted_85, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Referrals.Referral Code')), 1)]), _createElementVNode("div", _hoisted_86, _toDisplayString(_ctx.$t('Referrals.TotalRebates')), 1), _createElementVNode("div", _hoisted_87, _toDisplayString(_ctx.$t('Referrals.Total Interest')), 1), _createElementVNode("div", _hoisted_88, _toDisplayString(_ctx.$t('Referrals.Share link')), 1)]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressReferralCodes, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "mt-3"
    }, [_createElementVNode("div", _hoisted_89, [_createElementVNode("div", _hoisted_90, [_createElementVNode("span", null, _toDisplayString(item.referral), 1)]), _createElementVNode("div", _hoisted_91, [_createElementVNode("span", null, _toDisplayString(item.stakesReferred), 1)]), _createElementVNode("div", _hoisted_92, [_createElementVNode("span", null, _toDisplayString($options.formatWalletFilPrice(item.totalRebates, 4, false, false)), 1)]), _createElementVNode("div", _hoisted_93, [_createElementVNode("div", _hoisted_94, [_createElementVNode("div", null, [$data.isCopyIndex !== index ? (_openBlock(), _createElementBlock("span", {
      key: 0,
      class: "cursor-pointer icon-hover copy-text",
      onClick: $event => $options.copy(index, item.referral)
    }, [_createElementVNode("span", null, [_createVNode(_component_el_icon, {
      style: {
        "transform": "scale(1.2) translateY(1px)"
      }
    }, {
      default: _withCtx(() => [_createVNode(_component_CopyDocument)]),
      _: 1
    })])], 8, _hoisted_95)) : _createCommentVNode("", true), $data.isCopyIndex === index ? (_openBlock(), _createElementBlock("div", _hoisted_96, " copied ")) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_97, [_createElementVNode("div", {
      class: "cursor-pointer icon-hover",
      onClick: $event => $options.gotoTwitter(index, item.referral)
    }, _hoisted_100, 8, _hoisted_98)]), _createElementVNode("div", _hoisted_101, [_createElementVNode("div", {
      class: "copy-text2 cursor-pointer icon-hover",
      onClick: $event => $options.createPoster(item.referral)
    }, _hoisted_104, 8, _hoisted_102)])])])])]);
  }), 128))])) : _createCommentVNode("", true), !_ctx.addressReferralCodes || _ctx.addressReferralCodes.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_105, [_createElementVNode("span", _hoisted_106, _toDisplayString(_ctx.$t('Referrals.No referral codes')), 1)])) : _createCommentVNode("", true)])), [[_directive_loading, _ctx.addressReferralCodesLoading]])]), _createElementVNode("div", _hoisted_107, [_createElementVNode("div", _hoisted_108, [_createElementVNode("div", _hoisted_109, [_createElementVNode("span", _hoisted_110, [_createTextVNode(_toDisplayString(_ctx.$t('Referrals.Referral Details')), 1), _createElementVNode("span", _hoisted_111, "(" + _toDisplayString(_ctx.referralsCount) + ")", 1)])]), _withDirectives((_openBlock(), _createElementBlock("div", null, [_ctx.addressReferralHistory && _ctx.addressReferralHistory.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_112, [_createElementVNode("div", _hoisted_113, [_createElementVNode("div", _hoisted_114, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Referrals.Address')), 1)]), _createElementVNode("div", _hoisted_115, _toDisplayString(_ctx.$t('Referrals.Total Interest')), 1), _createElementVNode("div", _hoisted_116, _toDisplayString(_ctx.$t('Referrals.Referral Code')), 1), _hoisted_117]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.addressReferralHistory, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "mt-3"
    }, [_createElementVNode("div", _hoisted_118, [_createElementVNode("div", _hoisted_119, [_createElementVNode("span", null, _toDisplayString(item.address), 1)]), _createElementVNode("div", _hoisted_120, [_createElementVNode("span", null, _toDisplayString(item.interest === null || item.interest === undefined || item.interest === '' || $options.toBigInt(item.interest) <= 0n ? '0 FIL' : $options.formatWalletFilPrice(item.interest, 4, false)), 1)]), _createElementVNode("div", _hoisted_121, [_createElementVNode("span", null, _toDisplayString(item.referral), 1)])])]);
  }), 128)), _ctx.referralsCount > 10 ? (_openBlock(), _createElementBlock("div", _hoisted_122, [_createVNode(_component_el_pagination, {
    onCurrentChange: $options.changeHistory,
    layout: "prev, pager, next",
    total: _ctx.referralsCount
  }, null, 8, ["onCurrentChange", "total"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !_ctx.addressReferralHistory || _ctx.addressReferralHistory.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_123, [_createElementVNode("span", _hoisted_124, _toDisplayString(_ctx.$t('Referrals.No Rewards Distribution History yet')), 1)])) : _createCommentVNode("", true)])), [[_directive_loading, _ctx.addressReferralHistoryLoading]])])]), _createElementVNode("div", _hoisted_125, [_createElementVNode("div", _hoisted_126, [_createElementVNode("div", _hoisted_127, [_createElementVNode("div", null, [_createElementVNode("span", _hoisted_128, _toDisplayString(_ctx.$t('Referrals.Rewards Distribution History')), 1)])]), _createElementVNode("div", null, [_createElementVNode("div", _hoisted_129, [_createElementVNode("div", _hoisted_130, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Referrals.Settlement Period')), 1)]), _createElementVNode("div", _hoisted_131, _toDisplayString(_ctx.$t('Referrals.Current Interest')), 1), _createElementVNode("div", _hoisted_132, _toDisplayString(_ctx.$t('Referrals.Discount Rate')), 1), _createElementVNode("div", _hoisted_133, _toDisplayString(_ctx.$t('Referrals.Rebate Amount')), 1)]), _withDirectives((_openBlock(), _createElementBlock("div", null, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.snapshootList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "mt-3"
    }, [_createElementVNode("div", _hoisted_134, [_createElementVNode("div", _hoisted_135, [item.start_time !== null ? (_openBlock(), _createElementBlock("span", _hoisted_136, _toDisplayString($options.simpleDateFormatByMin(new Date(item.start_time).getTime())) + " - " + _toDisplayString($options.simpleDateFormatByMin(new Date(item.end_time).getTime())), 1)) : _createCommentVNode("", true), item.start_time === null ? (_openBlock(), _createElementBlock("span", _hoisted_137, [_createTextVNode(_toDisplayString(_ctx.$t('nft.Next epoch')) + ": ", 1), _createElementVNode("span", null, _toDisplayString(_ctx.nextEpochShow), 1)])) : _createCommentVNode("", true)]), _createElementVNode("div", _hoisted_138, [_createElementVNode("span", null, _toDisplayString($options.formatWalletFilPrice(item.rebate_interest, 4, false, false)), 1)]), _createElementVNode("div", _hoisted_139, [_createElementVNode("span", null, _toDisplayString(parseInt(item.subordinate_ratio) / 100) + "% ", 1)]), _createElementVNode("div", _hoisted_140, [_createElementVNode("span", null, _toDisplayString($options.formatWalletFilPrice(item.amount, 4, false, false)), 1)])])]);
  }), 128)), _ctx.withdrawHistoryTotal > 10 ? (_openBlock(), _createElementBlock("div", _hoisted_141, [_createVNode(_component_el_pagination, {
    onCurrentChange: $options.changeSnapshoot,
    layout: "prev, pager, next",
    total: _ctx.withdrawHistoryTotal
  }, null, 8, ["onCurrentChange", "total"])])) : _createCommentVNode("", true)])), [[_directive_loading, _ctx.snapshootInfoLoading]])]), !_ctx.snapshootList || _ctx.snapshootList.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_142, [_createElementVNode("span", _hoisted_143, _toDisplayString(_ctx.$t('Referrals.No settlement record')), 1)])) : _createCommentVNode("", true)])])]), _createElementVNode("div", _hoisted_144, [_createElementVNode("div", _hoisted_145, [_withDirectives((_openBlock(), _createElementBlock("div", _hoisted_146, [_createElementVNode("div", _hoisted_147, [_createElementVNode("span", _hoisted_148, _toDisplayString(_ctx.$t('Referrals.WithdrawRecord')), 1)]), _ctx.withdrawHistory && _ctx.withdrawHistory.length > 0 ? (_openBlock(), _createElementBlock("div", _hoisted_149, [_createElementVNode("div", _hoisted_150, [_createElementVNode("div", _hoisted_151, [_createElementVNode("span", null, _toDisplayString(_ctx.$t('Referrals.WithdrawTime')), 1)]), _createElementVNode("div", _hoisted_152, _toDisplayString(_ctx.$t('Referrals.WithdrawAmount')), 1), _createElementVNode("div", _hoisted_153, _toDisplayString(_ctx.$t('Referrals.Fee')), 1), _createElementVNode("div", _hoisted_154, _toDisplayString(_ctx.$t('Referrals.WithdrawStatus')), 1), _hoisted_155]), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.withdrawHistory, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      key: index,
      class: "mt-3"
    }, [_createElementVNode("div", _hoisted_156, [_createElementVNode("div", _hoisted_157, [_createElementVNode("span", null, _toDisplayString($options.simpleDateFormatByMin(new Date(item.create_time).getTime())), 1)]), _createElementVNode("div", _hoisted_158, [_createElementVNode("span", null, _toDisplayString(item.withdrawn === 0 ? '--' : $options.formatWalletFilPrice(item.withdrawn, 4, false)), 1)]), _hoisted_159, _createElementVNode("div", _hoisted_160, [item.status.toString() === '0' ? (_openBlock(), _createElementBlock("span", _hoisted_161, _toDisplayString(_ctx.$t('Referrals.WithdrawStatus_0')), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_162, [_createVNode(_component_el_icon, {
      size: "16"
    }, {
      default: _withCtx(() => [_createVNode(_component_SuccessFilled, {
        color: "#39dccf"
      })]),
      _: 1
    }), _createElementVNode("span", _hoisted_163, _toDisplayString(_ctx.$t('Referrals.WithdrawStatus_1')), 1)]))])])]);
  }), 128)), _ctx.withdrawHistoryTotal > 10 ? (_openBlock(), _createElementBlock("div", _hoisted_164, [_createVNode(_component_el_pagination, {
    onCurrentChange: $options.changeWithdraw,
    layout: "prev, pager, next",
    total: _ctx.withdrawHistoryTotal
  }, null, 8, ["onCurrentChange", "total"])])) : _createCommentVNode("", true)])) : _createCommentVNode("", true), !_ctx.withdrawHistory || _ctx.withdrawHistory.length === 0 ? (_openBlock(), _createElementBlock("div", _hoisted_165, [_createElementVNode("span", _hoisted_166, _toDisplayString(_ctx.$t('Referrals.No Withdraw Distribution History yet')), 1)])) : _createCommentVNode("", true)])), [[_directive_loading, _ctx.withdrawHistoryLoading]])])])])]), _createVNode(_component_el_dialog, {
    modelValue: $data.showGenerateCode,
    "onUpdate:modelValue": _cache[4] || (_cache[4] = $event => $data.showGenerateCode = $event),
    title: _ctx.$t('Referrals.GenerateCode'),
    top: "15%",
    width: "350",
    "close-on-press-escape": false,
    "close-on-click-modal": false,
    class: "show-generate-code-dialog",
    "before-close": $options.generateCodeHandleClose
  }, {
    default: _withCtx(() => [_createElementVNode("div", null, [_createVNode(_component_el_input, {
      disabled: $data.checkReferralsCodeLoading,
      style: {
        "height": "45px"
      },
      modelValue: $data.generateCode,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.generateCode = $event),
      onInput: $options.inputGenerateCode,
      ref: "generateCodeInput",
      placeholder: _ctx.$t('Referrals.GenerateCodeInput')
    }, null, 8, ["disabled", "modelValue", "onInput", "placeholder"])]), _createElementVNode("div", _hoisted_167, [_createElementVNode("span", _hoisted_168, _toDisplayString($data.referralCodeErrTips), 1)]), _createElementVNode("div", _hoisted_169, [!$data.generateCodeFinish ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      class: "btn btn-primary w-100 i-button",
      disabled: !$data.generateCodeFinish
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString($data.referralCodeButtonTips === '' ? _ctx.$t('Referrals.GenerateCodeInputBtn') : $data.referralCodeButtonTips), 1)]),
      _: 1
    }, 8, ["disabled"])) : _createCommentVNode("", true), $data.generateCodeFinish ? (_openBlock(), _createBlock(_component_el_button, {
      key: 1,
      class: "btn btn-primary w-100 i-button",
      onClick: $options.createReferralsCode,
      loading: $data.checkReferralsCodeLoading
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Referrals.Create')), 1)]),
      _: 1
    }, 8, ["onClick", "loading"])) : _createCommentVNode("", true)])]),
    _: 1
  }, 8, ["modelValue", "title", "before-close"]), _createVNode(_component_el_dialog, {
    class: "poster-dialog",
    modelValue: $data.posterDialogVisible,
    "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.posterDialogVisible = $event),
    title: _ctx.$t('Referrals.poster'),
    width: $data.posterDialogWidth,
    top: "5vh"
  }, {
    default: _withCtx(() => [_withDirectives((_openBlock(), _createElementBlock("div", {
      "element-loading-text": "Loading...",
      style: _normalizeStyle({
        height: $data.posterDialogHeight
      })
    }, [_createElementVNode("img", {
      style: {
        "width": "100%"
      },
      src: $data.posterImgList[0],
      alt: ""
    }, null, 8, _hoisted_170), _createElementVNode("div", _hoisted_171, [$data.canSaveImage ? (_openBlock(), _createBlock(_component_el_button, {
      key: 0,
      loading: $data.posterLoading,
      class: "btn btn-success w-100 i-button",
      onClick: $options.saveImage
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Referrals.saveImg')), 1)]),
      _: 1
    }, 8, ["loading", "onClick"])) : _createCommentVNode("", true), !$data.canSaveImage ? (_openBlock(), _createBlock(_component_el_button, {
      key: 1,
      disabled: true,
      class: "btn btn-info w-100 i-button",
      style: {
        "opacity": "1"
      }
    }, {
      default: _withCtx(() => [_createTextVNode(_toDisplayString(_ctx.$t('Referrals.NoCansaveImg')), 1)]),
      _: 1
    })) : _createCommentVNode("", true), _createElementVNode("div", {
      class: "flex-center mt-2 cursor-pointer",
      onClick: _cache[5] || (_cache[5] = $event => $data.posterDialogVisible = false)
    }, [_createVNode(_component_el_icon, {
      size: "36"
    }, {
      default: _withCtx(() => [_createVNode(_component_CircleClose, {
        color: "#ddd"
      })]),
      _: 1
    })])])], 4)), [[_directive_loading, $data.posterLoading]])]),
    _: 1
  }, 8, ["modelValue", "title", "width"])]);
}